/**
 * Rule base class
 */
export class PlanRule {
  constructor(type, description) {
    this.type = type;
    this.description = description;
  }
}
